<!--
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-14 15:50:31
 * @LastEditTime: 2026-04-14 19:51:16
 * @LastEditors: ranli
-->
<template>
  <van-tabs v-model="active" class="top-tabs" sticky :offset-top="0" background="#fff" color="#D82D2C"
    title-active-color="#D82D2C" title-inactive-color="#7C8AA2" :line-height="2" @click-tab="onClickTab">
    <van-tab v-for="tab in tabs" :key="tab.name" :name="tab.name">
      <template #title>
        <div class="tab-title" :class="{ active: active === tab.name }">
          <SvgIcon :name="tab.iconName" :size="30" />
          <div>{{ tab.title }}</div>
        </div>
      </template>
    </van-tab>
  </van-tabs>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SvgIcon from '@/components/SvgIcon/index.vue'

const route = useRoute()
const router = useRouter()

const tabs = [
  { name: 'TopHome', title: 'Home', path: 'home', iconName: 'tabbar/home' },
  { name: 'TopMatches', title: 'My Matches', path: 'matches', iconName: 'tabbar/myMatches' },
  { name: 'TopRewards', title: 'Rewards', path: 'rewards', iconName: 'tabbar/rewards' },
]

const active = ref('')

watch(
  () => route.name,
  (name) => {
    if (tabs.some(t => t.name === name)) {
      active.value = name
    }
  },
  { immediate: true },
)

const onClickTab = ({ name }) => {
  const tab = tabs.find(t => t.name === name)
  if (tab) {
    router.replace({ name: tab.name })
  }
}
</script>

<style scoped lang="less">
.top-tabs {
  :deep(.van-tabs__wrap) {
    border-bottom: 1px solid #f0f0f0;
  }

  :deep(.van-tab) {
    font-size: 14px;
    font-weight: 500;
  }

  :deep(.van-tab--active) {
    font-weight: 600;
  }

  .tab-title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    color: #7C8AA2;
    transition: color 0.2s ease;

    &.active {
      color: #D82D2C;
    }

    .tab-icon {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
